import { mouseover } from './modules/mouseover';
import { hamburger } from './modules/hamburger';
import { dropdown } from './modules/dropdown';
import { allLink } from './modules/allLink';
import { smoothscroll } from './modules/smoothscroll';
mouseover();
hamburger();
dropdown();
allLink();
smoothscroll();